import { useEffect, useState } from 'react';

interface Coords {
  latitude?: number;
  longitude?: number;
  radius?: number;
}

const RADIUS = 5000;

// By client requirement, default coords to be central
// https://generali-hk.atlassian.net/jira/software/projects/AIOBRB/boards/81?assignee=62e0dcbe9974783acc3520f3&selectedIssue=AIOBRB-1175
export const CENTRAL_COORDS = {
  latitude: 22.282115399579208,
  longitude: 114.15824999685758,
};

const useCoordinates = () => {
  const [coords, setCoords] = useState<Coords>();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setCoords({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          radius: RADIUS,
        });
      },
      (error) => console.log(error),
    );
  }, []);

  return { coords };
};

export default useCoordinates;
